import React from 'react';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';

interface Props {
  open: boolean;
  message?: string;
}

export const LoadingBackdrop: React.FC<Props> = ({
  open,
  message = 'Loading...'
}) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      }}
      open={open}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          bgcolor: 'white',
          p: 4,
          borderRadius: 2,
        }}
      >
        <CircularProgress size={48} />
        <Typography variant="body1" color="text.primary">
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
};
